module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": require("../../assets/posters/mustardSeed.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Mustard Seed Network")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Mustard Seed Network exists to glorify God by making disciples through planting gospel-centered churches in urban Japan.    To see the cities of Japan saturated with and impacted by gospel-centered churches that further the global cause of Jesus Christ.  Their goal is to recruit and train church planters, catalyze church plants, and support church planters and church plants.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": require("../../assets/projects/mustard-seed/mustardSeedTestimonial.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Jay Greer")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Pastor at Mustard Seed Christian Church Osaka")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("President of Mustard Seed Network")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Famous King has blessed our ministry with high-quality videos that we wouldn't have been able to afford without the amazing financial partnership program of Famous King. Having seen Derek's work in the past I knew we would get a fantastic, professional product. However, I was further impressed by the way Derek came and learned our ministry. He represented us, our vision, our values, and our mission in a way that captured the heart of what we do. We're thankful for the impact Famous King has made both in our target group in Japan and on our supporters around the world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-133c2030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/MustardSeed.vue
// module id = 72
// module chunks = 0